// TIBECO - Dashboard Stocuri și Inventar
import React, { useState } from 'react';
import { 
  Package, 
  AlertTriangle, 
  TrendingUp, 
  Truck,
  Search,
  Filter,
  Plus,
  Eye,
  BarChart3,
  Boxes,
  ShoppingCart,
  RefreshCw
} from 'lucide-react';
import Card from '../../components/Card';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const InventoryDashboard = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('toate');
  const [showStockModal, setShowStockModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // KPI-uri Stocuri
  const stockKPIs = {
    valoareTotala: 1245000,
    articole: 156,
    alerteStoc: 12,
    comenziPending: 8
  };

  // Stocuri TIBECO - Materiale specializate pentru ferestre și uși
  const stockItems = [
    {
      id: 1,
      nume: 'Profile PVC REHAU Euro-Design 70',
      categorie: 'Profile PVC',
      cod: 'PVC-RH-70-ALB',
      cantitate: 245,
      unitateMasura: 'ml',
      stocMinim: 100,
      pretUnitar: 45.50,
      valoareStoc: 11152.50,
      furnizor: 'REHAU România',
      locatie: 'Depozit A - Raft 1',
      ultimaReceptie: '2024-09-01',
      status: 'optim',
      specificatii: {
        dimensiuni: '70mm sistem',
        culoare: 'Alb',
        clasa: 'A',
        rezistenta: '-40°C / +60°C'
      }
    },
    {
      id: 2,
      nume: 'Profile Aluminiu Schüco AWS 75.SI',
      categorie: 'Profile Aluminiu',
      cod: 'ALU-SC-75-ANT',
      cantitate: 89,
      unitateMasura: 'ml',
      stocMinim: 50,
      pretUnitar: 125.80,
      valoareStoc: 11196.20,
      furnizor: 'Schüco International',
      locatie: 'Depozit A - Raft 3',
      ultimaReceptie: '2024-08-28',
      status: 'optim',
      specificatii: {
        dimensiuni: '75mm sistem',
        culoare: 'Antracit RAL 7016',
        clasa: 'Premium',
        izolare: 'Rupere de punte termică'
      }
    },
    {
      id: 3,
      nume: 'Sticlă Termopan 4+16+4 Low-E',
      categorie: 'Sticlă',
      cod: 'STI-TERM-416-LE',
      cantitate: 34,
      unitateMasura: 'm²',
      stocMinim: 50,
      pretUnitar: 185.00,
      valoareStoc: 6290.00,
      furnizor: 'Guardian Glass România',
      locatie: 'Depozit Sticlă - Zona 1',
      ultimaReceptie: '2024-08-30',
      status: 'critic',
      specificatii: {
        tip: 'Termopan dublu',
        grosime: '24mm total',
        coating: 'Low-E pe fața 3',
        gaz: 'Argon 90%'
      }
    },
    {
      id: 4,
      nume: 'Feronerie MACO MULTI-TREND',
      categorie: 'Feronerie',
      cod: 'FER-MC-MT-STD',
      cantitate: 78,
      unitateMasura: 'set',
      stocMinim: 30,
      pretUnitar: 89.50,
      valoareStoc: 6981.00,
      furnizor: 'MACO România',
      locatie: 'Depozit B - Raft 5',
      ultimaReceptie: '2024-09-03',
      status: 'optim',
      specificatii: {
        tip: 'Oscilo-batant',
        sarcina: 'Până la 130kg',
        securitate: 'Anti-efracție RC2',
        finish: 'Zinc'
      }
    },
    {
      id: 5,
      nume: 'Mânere Hoppe Atlanta',
      categorie: 'Accesorii',
      cod: 'MAN-HP-ATL-ALB',
      cantitate: 145,
      unitateMasura: 'buc',
      stocMinim: 50,
      pretUnitar: 32.50,
      valoareStoc: 4712.50,
      furnizor: 'Hoppe România',
      locatie: 'Depozit B - Raft 2',
      ultimaReceptie: '2024-08-25',
      status: 'optim',
      specificatii: {
        material: 'Aluminiu',
        culoare: 'Alb RAL 9016',
        tip: 'Cu cheie',
        standard: 'DIN'
      }
    },
    {
      id: 6,
      nume: 'Garnituri EPDM Negre',
      categorie: 'Consumabile',
      cod: 'GAR-EPDM-NEG-6',
      cantitate: 8,
      unitateMasura: 'role 100ml',
      stocMinim: 15,
      pretUnitar: 45.00,
      valoareStoc: 360.00,
      furnizor: 'Techno Polymer',
      locatie: 'Depozit B - Raft 8',
      ultimaReceptie: '2024-07-15',
      status: 'critic',
      specificatii: {
        material: 'EPDM',
        duritate: '65±5 Shore A',
        temperatura: '-40°C / +120°C',
        culoare: 'Negru'
      }
    },
    {
      id: 7,
      nume: 'Silicon Structural DOWSIL',
      categorie: 'Consumabile',
      cod: 'SIL-DOW-STR-BLK',
      cantitate: 23,
      unitateMasura: 'cartus 310ml',
      stocMinim: 40,
      pretUnitar: 28.90,
      valoareStoc: 664.70,
      furnizor: 'Dow Chemical România',
      locatie: 'Depozit B - Raft 9',
      ultimaReceptie: '2024-08-20',
      status: 'scazut',
      specificatii: {
        tip: 'Structural glazing',
        culoare: 'Negru',
        timp_vulcanizare: '24h',
        adeziune: 'Aluminiu, Sticlă'
      }
    },
    {
      id: 8,
      nume: 'Yală Multipoint YALE Superior',
      categorie: 'Securitate',
      cod: 'YAL-SUP-MP-55',
      cantitate: 42,
      unitateMasura: 'buc',
      stocMinim: 20,
      pretUnitar: 145.00,
      valoareStoc: 6090.00,
      furnizor: 'YALE România',
      locatie: 'Depozit C - Seif',
      ultimaReceptie: '2024-09-02',
      status: 'optim',
      specificatii: {
        tip: '5 puncte de închidere',
        distanta: '55mm',
        cilindru: 'Include cilindru europrofil',
        certificare: 'EN 12209'
      }
    },
    {
      id: 9,
      nume: 'Balamale Simonswerk BAKA 3D',
      categorie: 'Feronerie',
      cod: 'BAL-SW-BK3D-160',
      cantitate: 67,
      unitateMasura: 'set 3 buc',
      stocMinim: 25,
      pretUnitar: 78.50,
      valoareStoc: 5259.50,
      furnizor: 'Simonswerk România',
      locatie: 'Depozit B - Raft 6',
      ultimaReceptie: '2024-08-29',
      status: 'optim',
      specificatii: {
        lungime: '160mm',
        reglaj: '3D - toate axele',
        sarcina: 'Până la 160kg',
        material: 'Oțel zincat'
      }
    },
    {
      id: 10,
      nume: 'Sticlă Securizată 8mm',
      categorie: 'Sticlă',
      cod: 'STI-SEC-8MM-CL',
      cantitate: 18,
      unitateMasura: 'm²',
      stocMinim: 30,
      pretUnitar: 95.00,
      valoareStoc: 1710.00,
      furnizor: 'Pilkington România',
      locatie: 'Depozit Sticlă - Zona 2',
      ultimaReceptie: '2024-08-15',
      status: 'scazut',
      specificatii: {
        tip: 'Securizată termică',
        grosime: '8mm',
        transparenta: '90%',
        rezistenta: 'Clasa 1B1 EN 356'
      }
    }
  ];

  // Filtrare stocuri
  const filteredItems = stockItems.filter(item => {
    const matchesSearch = item.nume.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.cod.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'toate' || item.categorie === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // Categorii disponibile
  const categorii = ['toate', ...new Set(stockItems.map(item => item.categorie))];

  // Articole cu stoc critic sau scăzut
  const articoleCritice = stockItems.filter(item => item.status === 'critic' || item.status === 'scazut');

  const getStatusColor = (status) => {
    switch(status) {
      case 'optim': return 'success';
      case 'scazut': return 'warning';
      case 'critic': return 'error';
      default: return 'gray';
    }
  };

  const getStatusText = (status) => {
    switch(status) {
      case 'optim': return 'Stoc Optim';
      case 'scazut': return 'Stoc Scăzut';
      case 'critic': return 'Stoc Critic';
      default: return 'Necunoscut';
    }
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowStockModal(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              Stocuri & Inventar TIBECO
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Gestionarea stocurilor de materiale pentru ferestre și uși
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 mt-4 sm:mt-0">
            <button className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              <RefreshCw className="w-4 h-4 mr-2" />
              Sincronizare
            </button>
            <button className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">
              <Plus className="w-4 h-4 mr-2" />
              Adaugă Articol
            </button>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-green-100 dark:bg-green-900 rounded-xl">
                <Package className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
              {stockKPIs.valoareTotala.toLocaleString()} RON
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Valoare Totală Stoc
            </p>
          </Card>

          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-xl">
                <Boxes className="w-6 h-6 text-blue-600" />
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
              {stockKPIs.articole}
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Articole în Stoc
            </p>
          </Card>

          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-red-100 dark:bg-red-900 rounded-xl">
                <AlertTriangle className="w-6 h-6 text-red-600" />
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
              {stockKPIs.alerteStoc}
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Alerte de Stoc
            </p>
          </Card>

          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-yellow-100 dark:bg-yellow-900 rounded-xl">
                <ShoppingCart className="w-6 h-6 text-yellow-600" />
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
              {stockKPIs.comenziPending}
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Comenzi în Așteptare
            </p>
          </Card>
        </div>

        {/* Alertele de Stoc */}
        {articoleCritice.length > 0 && (
          <Card className="p-6 mb-8 border-l-4 border-red-500">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center">
                <AlertTriangle className="w-5 h-5 text-red-500 mr-2" />
                Alerte de Stoc
              </h2>
              <Badge variant="error">{articoleCritice.length} articole</Badge>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {articoleCritice.map((item) => (
                <div key={item.id} className="p-4 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-medium text-gray-900 dark:text-white truncate">
                      {item.nume}
                    </h3>
                    <Badge variant={getStatusColor(item.status)} size="sm">
                      {getStatusText(item.status)}
                    </Badge>
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">
                    <p>Stoc actual: <span className="font-medium">{item.cantitate} {item.unitateMasura}</span></p>
                    <p>Stoc minim: <span className="font-medium">{item.stocMinim} {item.unitateMasura}</span></p>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        )}

        {/* Filtre și Căutare */}
        <Card className="p-6 mb-8">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Caută după nume sau cod articol..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                />
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <Filter className="w-5 h-5 text-gray-400" />
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              >
                {categorii.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat === 'toate' ? 'Toate categoriile' : cat}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Card>

        {/* Tabel Stocuri */}
        <Card className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Inventar Materiale
            </h2>
            <Badge variant="primary" className="px-3 py-1">
              {filteredItems.length} articole
            </Badge>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 dark:border-gray-700">
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Articol</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Categorie</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Stoc</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Status</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Valoare</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Locație</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Acțiuni</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((item) => (
                  <tr 
                    key={item.id}
                    className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                    onClick={() => handleItemClick(item)}
                  >
                    <td className="py-4 px-4">
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white">
                          {item.nume}
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">
                          {item.cod}
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-4">
                      <span className="text-sm text-gray-900 dark:text-white">
                        {item.categorie}
                      </span>
                    </td>
                    <td className="py-4 px-4">
                      <div>
                        <div className="font-medium text-gray-900 dark:text-white">
                          {item.cantitate} {item.unitateMasura}
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">
                          Min: {item.stocMinim}
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-4">
                      <Badge variant={getStatusColor(item.status)}>
                        {getStatusText(item.status)}
                      </Badge>
                    </td>
                    <td className="py-4 px-4">
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white">
                          {item.valoareStoc.toLocaleString()} RON
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">
                          {item.pretUnitar.toFixed(2)} RON/{item.unitateMasura}
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-4">
                      <span className="text-sm text-gray-600 dark:text-gray-400">
                        {item.locatie}
                      </span>
                    </td>
                    <td className="py-4 px-4">
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          handleItemClick(item);
                        }}
                        className="p-1 text-gray-400 hover:text-primary-600 transition-colors"
                      >
                        <Eye className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* Modal Detalii Articol */}
      <Modal isOpen={showStockModal} onClose={() => setShowStockModal(false)}>
        {selectedItem && (
          <div className="p-6 max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
                  {selectedItem.nume}
                </h2>
                <p className="text-gray-600 dark:text-gray-400">
                  Cod: {selectedItem.cod}
                </p>
              </div>
              <Badge variant={getStatusColor(selectedItem.status)}>
                {getStatusText(selectedItem.status)}
              </Badge>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
              {/* Informații Stoc */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Stoc</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Cantitate:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedItem.cantitate} {selectedItem.unitateMasura}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Stoc minim:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedItem.stocMinim} {selectedItem.unitateMasura}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Locație:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedItem.locatie}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Ultima recepție:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {new Date(selectedItem.ultimaReceptie).toLocaleDateString('ro-RO')}
                    </span>
                  </div>
                </div>
              </Card>

              {/* Informații Financiare */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Financiare</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Preț unitar:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedItem.pretUnitar.toFixed(2)} RON
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Valoare stoc:</span>
                    <span className="font-bold text-primary-600">
                      {selectedItem.valoareStoc.toLocaleString()} RON
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Furnizor:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedItem.furnizor}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Categorie:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedItem.categorie}
                    </span>
                  </div>
                </div>
              </Card>

              {/* Specificații Tehnice */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Specificații Tehnice</h3>
                <div className="space-y-2 text-sm">
                  {Object.entries(selectedItem.specificatii).map(([key, value]) => (
                    <div key={key} className="flex justify-between">
                      <span className="text-gray-600 dark:text-gray-400 capitalize">
                        {key.replace('_', ' ')}:
                      </span>
                      <span className="font-medium text-gray-900 dark:text-white">
                        {value}
                      </span>
                    </div>
                  ))}
                </div>
              </Card>
            </div>

            <div className="flex justify-end space-x-3">
              <button className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                Istoric Mișcări
              </button>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                Comandă Suplimentară
              </button>
              <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">
                Editează Articol
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default InventoryDashboard;